'use strict';
const CognitoLib = require('./cognito-lib'),
	cognitoModels = require('./cognito-models'),
	cognitoWidgets = require('./cognito-widgets');
module.exports = function cognitoStart(config, goldApi, subscriptionModel, authenticationModel, reauthenticator, navigatorShim) {
	const models = cognitoModels(CognitoLib, config, goldApi, authenticationModel, reauthenticator, navigatorShim);
	cognitoWidgets(models, authenticationModel, subscriptionModel);
	return models;
};
